<div *ngIf="loaded == 1">

  <!---------------------------------------------------------------------------------------------------- BANNER   -->
  <section class="backDark banner pdt70 pdb30">
    <div class="cw" fxLayout="row" fxLayoutGap="300px">
      <img [src]=instructor.foto class="imgInstructor">
      <div></div>
      <div fxLayout="column" fxLayoutAlign="end " class="zIndex1">
        <div fxLayout="row" fxLayoutAlign=" center">
          <h5 class="gray-1a mgb0 mgr10"> {{instructor.nombre}}</h5>
        </div>
        <h6 class="light-link-color ft300 ft16">{{instructor.resumen}}</h6>

      </div>
    </div>
  </section>

  <!----------------------------------------------------------------------------------------------------RESUMEN INSTRUCTOR  -->

  <section class=" pd60">

    <div class="cw">

      <div fxLayout="row" fxLayoutAlign="space-between center" class="mgb10">
        <h6 class="ft500 ft17 mg0">Resumen de instructor</h6>
      </div>

      <div fxLayout="row" fxLayoutGap="" class="border">

        <div fxLayout="column" fxFlex="100%" fxLayoutAlign="center center" class="border-r radius3 pd10">
          <h6 class="centertext gray-7 ft13"> Total cursos </h6>
          <p class="ftxl centertext mgb0 gray-9"> {{instructor.cantCursos}}</p>
        </div>

        <div fxLayout="column" fxFlex="100%" fxLayoutAlign="center center" class="border-r radius3 pd10">
          <h6 class="centertext gray-7 ft13"> Inscritos </h6>
          <p class="ftxl centertext mgb0 gray-9"> {{cantInscritos}}</p>
        </div>

        <div fxLayout="column" fxFlex="100%" fxLayoutAlign="center center" class="border-r radius3 pd10">
          <h6 class="centertext gray-7 ft13"> Ganancia Acum. (USD) </h6>
          <p class="ftxl centertext mgb0 gray-9"> {{gananciaAcum}}</p>
        </div>

        <div fxLayout="column" fxFlex="100%" fxLayoutAlign="center center" class="radius3 pd10">
          <h6 class="centertext gray-7 ft13"> Por cobrar (USD) </h6>
          <p class="ftxl centertext mgb0 gray-9"> {{porCobrar}}</p>
        </div>
      </div>


      <!----------------------------------------------------------------------------- CURSOS DE INSTRUCTOR -->

      <h6 class="mgt40 ft500 ft16"> Cursos de instructor </h6>

      <mat-accordion class="fw">
        <mat-expansion-panel hideToggle *ngFor="let item of cursos" class="radius0 shadow0">
          <mat-expansion-panel-header class="backWhite radius0">
            <mat-panel-title class="fw">

              <!-- mat expansion title -->
              <span class="w-90 ft14">{{item.titulo}}</span>

            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="backLight pd10 radius3 mgb10">

            <!-- matt expansion info -->
            <div>
              <span class="title">Fecha de creación </span>
              <span>{{item.fechaCreacion.toDate() | date}}</span>
            </div>

            <div>
              <span class="title">Precio Original </span>
              <span>{{item.precioOriginal}}</span>
            </div>

            <div>
              <span class="title">Porcentaje de descuento: </span>
              <span>{{item.porcentajeDescuento}}%</span>
            </div>

            <div>
              <span class="title">Precio con descuento actual: </span>
              <span>{{item.precioFinal}} USD</span>
            </div>

            <div>
              <span class="title">Total inscritos: </span>
              <span>{{item.cantVentas}}</span>
            </div>

            <div>
              <span class="title">Estatus actual: </span>
              <span *ngIf="item.publicado; else noPublicado">Publicado</span>
              <ng-template #noPublicado>No publicado</ng-template>
            </div>

          </div>

        </mat-expansion-panel>
      </mat-accordion>


      <!----------------------------------------------------------------------------- HISTORICO DE PAGOS RECIBIDOS -->

      <h6 class="mgt40 ft500 ft16"> Historico de pagos recibidos </h6>

      <!-- Fila Contenedor -->
      <div *ngFor="let item of pagos;  let i=index">
        <div fxLayoutAlign="space-between" class="pdt10 pdb10 pdr10 border-t">

          <!-- Info -->
          <div fxLayout="row">
            <span class="centertext ft11"> {{item.instructorFechaPago.toDate() | date}}</span>
            <a routerLink="/inst/detalle-pago/{{item.pagoId}}"
              class="mgl20 blueLink undrl ft500 ft12">{{item.pagoId}}</a>
          </div>
          <div fxLayout="row">
            <div>
              <div *ngIf="item.instructorEstatusPago==='pagado'" class="sqChip backGreen5 ft11">
                {{item.instructorEstatusPago}}
              </div>
              <div *ngIf="item.instructorEstatusPago==='pendiente'" class="sqChip backRed5 ft11">
                {{item.instructorEstatusPago}}
              </div>
              <div *ngIf="item.instructorEstatusPago==='en proceso'" class="sqChip backOrange3 ft11">
                {{item.instructorEstatusPago}}
              </div>
            </div>
            <div>
              <span class="mgl20 centertext nowrap"> {{item.pagoTotal}} USD</span>
            </div>
          </div>
      

        </div>
      </div>

      <!----------------------------------------------------------------------------- HISTORICO DE PAGOS VENTAS -->

      <h6 class="mgt30 ft16 ft500"> Histórico de ventas </h6>

      <!-- Expansion panel -->
      <mat-accordion class="fw">
        <mat-expansion-panel hideToggle *ngFor="let item of ventas" class="radius0 shadow0">
          <mat-expansion-panel-header class="backWhite radius0">
            <mat-panel-title class="fw">

              <!-- Expansion panel header -->
              <div fxLayout="row" fxLayoutAlign="space-between" fxFlex="100%">
                <div fxLayout="row" fxFlex="100%">
                  <span class="w-10">{{item.transaccionFecha.toDate() | date}}</span>
                  <span class="w-70">{{item.cursoTitulo}} </span>
                </div>
                <div *ngIf="item.transaccionViaCobro!='obsequio'">
                  <div *ngIf="item.instructorEstatusPago==='pagado'" class="sqChip ft12 backGreen5 gray-1">
                    {{item.instructorEstatusPago}} </div>
                  <div *ngIf="item.instructorEstatusPago==='pendiente'" class="sqChip ft12 backRed5 gray-1">
                    {{item.instructorEstatusPago}} </div>
                </div>
                <div *ngIf="item.transaccionViaCobro==='obsequio'">
                  <div  class="sqChip ft12 backGreen5 gray-1">
                    No aplica pago </div>
                </div>
              </div>

            </mat-panel-title>
            <mat-panel-description>

              <!-- Total -->
              <span class="nowrap">{{item.instructorTotal}} USD</span>

            </mat-panel-description>
          </mat-expansion-panel-header>

          <!-- Expansion panel body -->
          <div class="backLight pd10 mgb10 radius3">

            <!-------------------------------------------------------------- Usuario -->

            <div>
              <span class="ft12 ft500 gray-6">Usuario: </span>
            </div>
            <div>

              <div>
                <span class="title">Nombre: </span>
                <span>{{item.usuarioNombre}}</span>
              </div>

              <div>
                <span class="title">Tipo: </span>
                <span>{{item.usuarioTipo}}</span>
              </div>
            </div>

            <!-------------------------------------------------------------- Curso-->

            <div class="mgt10">
              <span class="ft12 ft500 gray-6">Curso: </span>
            </div>
            <div>

              <div>
                <span class="title">Título: </span>
                <span>{{item.cursoTitulo}}</span>
              </div>

              <div>
                <span class="title">Precio Original: </span>
                <span>{{item.cursoPrecioOriginal}}</span>
              </div>

              <div>
                <span class="title">Descuento: </span>
                <span>{{item.cursoPorcentajeDescuento}}%</span>
              </div>

              <div>
                <span class="title">Precio Final: </span>
                <span>{{item.cursoPrecioFinal}}</span>
              </div>
            </div>

            <!-------------------------------------------------------------- Transaccion -->
            <div class="mgt10">
              <span class="ft12 ft500 gray-6">Transacción: </span>
            </div>

            <div>
              <div>
                <span class="title">Moneda: </span>
                <span>{{item.transaccionMoneda}}</span>
              </div>

              <div>
                <span class="title">Fecha: </span>
                <span>{{item.transaccionFecha.toDate() | date}}</span>
              </div>

              <div>
                <span class="title">Estatus Cobro: </span>
                <span>{{item.transaccionEstatusCobro}}</span>
              </div>

              <div>
                <span class="title">Via cobro: </span>
                <span>{{item.transaccionViaCobro}}</span>
              </div>

              <div>
                <span class="title">Transaccion Id: </span>
                <span>{{item.transaccionId}}</span>
              </div>

              <div>
                <span class="title">Comentario: </span>
                <span>{{item.transaccionComentario}}</span>
              </div>
            </div>

            <!------------------------------------------------------------- instructor -->

            <div class="mgt10">
              <span class="ft12 ft500 gray-6">Instructor: </span>
            </div>
            <div>

              <div>
                <span class="title">Porcentaje: </span>
                <span>{{item.instructorPorcentaje}}</span>
              </div>

              <div>
                <span class="title">Total: </span>
                <span>{{item.instructorTotal}}</span>
              </div>

              <div>
                <span class="title">Estatus Pago: </span>
                <span>{{item.instructorEstatusPago}}</span>
              </div>

              <div>
                <span class="title">Fecha Pago: </span>
                <span *ngIf="item.instructorFechaPago">{{item.instructorFechaPago.toDate() | date}}</span>
              </div>

              <div>
                <span class="title">Via Pago: </span>
                <span>{{item.instructorViaPago}}</span>
              </div>

              <div>
                <span class="title">Pago Id: </span>
                <span>{{item.pagoId}}</span>
              </div>
            </div>

          </div>

        </mat-expansion-panel>
      </mat-accordion>


    </div>
  </section>
</div>


<div *ngIf="loaded == 0">
  <div *ssrExclude>
    <spinner></spinner>
</div>
</div>